import React, {Component} from "react";
import Navbarmenu from './Navbarmenu';
import ReactDOM from "react-dom";
import data from '../data/ApplicationDevelopment.json'
import Container from '@material-ui/core/Container';
class RoleBasedContentDemo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			RoleFamilies : [],
			Roles : [],
			cities : [],
      level:[],
      filteredData: [],
			selectedCountry : '--Choose Country--',
			selectedState : '--Choose State--',
      selectedCity:'---choose city--',
      levelPlaceHolderValue:'--Level--'
		};
		this.changeCountry = this.changeCountry.bind(this);
		this.changeState = this.changeState.bind(this);
	}
  
	componentDidMount() {
		this.setState({
			RoleFamilies : [
				{ name: 'Application Development', 
        Roles: [
           {name: 'Application Development Senior Manager', level:['6']},
           {name: 'Application Development Manager', level:['7']},
           {name: 'Application Development Associate Manager', level:['8']},
           {name: 'Application Development Team Lead/Specialist', level:['9']},
           {name: 'Application Development Senior Analyst', level:['10']},
           {name: 'Application Development Analyst',level:['11'] },
           ] },

			  { name: 'Software Engineering', 
        Roles: [ 
          {name: 'Software Engineering Senior Manager', level:['6']},
          {name: 'Software Engineering Manager', level:['7']},
          {name: 'Software Engineering Associate Manager', level:['8']},
          {name: 'Software Engineering Specialist', level:['9']},
          {name: 'Software Engineering Senior Analyst', level:['10']},
          {name: 'Software Engineering Analyst',level:['11']},
           ] },


           { name: 'Technology Delivery Lead', 
        Roles: [ 
          {name: 'Technology Delivery Lead Senior Manager', level:['6']},
          {name: 'Technology Delivery Lead Manager', level:['7']},
          {name: 'Technology Delivery Lead Associate Manager', level:['8']},
          {name: 'Technology Delivery Lead Team Lead', level:['9']}
          
           ] },


           { name: 'Advanced Application Engineering', 
           Roles: [ 
             {name: 'Advanced Application Engineering Senior Manager', level:['6']},
             {name: 'Advanced Application Engineering Manager', level:['7']},
             {name: 'Advanced Application Engineering Associate Manager', level:['8']},
             {name: 'Advanced Application Engineering Specialist', level:['9']},
             {name: 'Advanced Application Engineering Senior Analyst', level:['10']},
             {name: 'Advanced Application Engineering Analyst',level:['11']},
              ] },

           
           { name: 'Application Automation Engineering', 
        Roles: [ 
          {name: 'Application Automation Engineering Senior Manager', level:['6']},
          {name: 'Application Automation Engineering Manager', level:['7']},
          {name: 'Application Automation Engineering Associate Manager', level:['8']},
          {name: 'Application Automation Engineering Specialist', level:['9']}
          
           ] },


           { name: 'Technology Architecture Delivery', 
        Roles: [ 
          {name: 'Technology Architecture Delivery Senior Manager', level:['6']},
          {name: 'Technology Architecture Delivery Manager', level:['7']},
          {name: 'Technology Architecture Delivery Associate Manager', level:['8']},
          {name: 'Technology Architecture Delivery Specialist/Team Lead', level:['9']}
          
           ] },

           { name: 'Test Architecture Engineering', 
        Roles: [ 
          {name: 'Test Architecture Engineering Senior Manager', level:['6']},
          {name: 'Test Architecture Engineering Manager', level:['7']},
          {name: 'Test Architecture Engineering Associate Manager', level:['8']},
          {name: 'Test Architecture Engineering Specialist', level:['9']}
         
           ] },

           
           { name: 'Test Automation Engineering', 
        Roles: [ 
          {name: 'Test Automation Engineering Senior Manager', level:['6']},
          {name: 'Test Automation Engineering Manager', level:['7']},
          {name: 'Test Automation Engineering Associate Manager', level:['8']},
          {name: 'Test Automation Engineering Specialist', level:['9']},
          {name: 'Test Automation Engineering Senior Analyst', level:['10']}
         
           ] },

           { name: 'Test Engineering', 
        Roles: [ 
          
          {name: 'Test Engineering Associate Manager', level:['8']},
          {name: 'Test Engineering Specialist', level:['9']},
          {name: 'Test Engineering Senior Analyst', level:['10']},
          {name: 'Test Engineering Analyst', level:['11']},
          {name: 'Test Engineering Associate', level:['12']},
         
           ] },

          { name: 'Scrum Master', 
        Roles: [ 
          {name: 'Scrum Master Senior Manager', level:['6']},
          {name: 'Scrum Master Manager', level:['7']},
          {name: 'Scrum Master Associate Manager', level:['8']},
          {name: 'Scrum Master Specialist', level:['9']},
                  
           ] },

           { name: 'Security Delivery', 
        Roles: [ 
          {name: 'Security Delivery Senior Manager', level:['6']},
          {name: 'Security Delivery Manager', level:['7']},
          {name: 'Security Delivery Associate Manager', level:['8']},
          {name: 'Security Delivery Specialist/Team Lead', level:['9']},
          {name: 'Security Delivery Senior Analyst', level:['10']},
          {name: 'Security Delivery Analyst',level:['11']},
          {name: 'Security Delivery Associate',level:['12']},
          {name: 'Security Delivery New Associate',level:['13']},
           ] },

           { name: 'Application/Cloud Support', 
        Roles: [ 
          
          {name: 'Application/Cloud Support Manager', level:['7']},
          {name: 'Application/Cloud Support Associate Manager', level:['8']},
          {name: 'Application/Cloud Support Specialist', level:['9']},
          {name: 'Application/Cloud Support Senior Analyst', level:['10']},
          {name: 'Application/Cloud Support Analyst',level:['11']},
          {name: 'Application/Cloud Support Associate',level:['12']},
          {name: 'Application/Cloud Support New Associate',level:['13']},
           ] },

           { name: 'Full Stack Engineering', 
        Roles: [ 
          {name: 'Full Stack Engineering Senior Manager', level:['6']},
          {name: 'Full Stack Engineering Manager', level:['7']},
          {name: 'Full Stack Engineering Associate Manager', level:['8']},
          {name: 'Full Stack Engineering Specialist', level:['9']},
          {name: 'Full Stack Engineering Senior Analyst', level:['10']},
          {name: 'Full Stack Engineering Analyst',level:['11']},
          
           ] },

				// { name: 'USA', Roles: [ {name: 'C', cities: ['Downers Grove']} ] },
				// { name: 'Mexico', Roles: [ {name: 'D', cities: ['Puebla']} ] },
				// { name: 'India', Roles: [ {name: 'E', cities: ['Delhi', 'Kolkata', 'Mumbai', 'Bangalore']} ] },
			]
		});
	}
  
//   data.payload.map((payload) => {
//     return payload.brands.map(brand =>{
//         return brand.subProducts.map(subProduct => {
//           return `${payload.name}, ${brand.name}, ${subProduct.name}`
//         }).join("\n")
//     }).join("\n")
// }).join("\n")



  


	changeCountry(event) {
		this.setState({
      selectedCountry: event.target.value, 
      Roles : Array.from(this.state.RoleFamilies.find(cntry => cntry.name === event.target.value).Roles),
      level: []
    },
      ()=>console.log(this.state.Roles)  
      
      );
		
// this.setState({Roles : Array.from(this.state.RoleFamilies.find(cntry => cntry.name === event.target.value).Roles)},()=>console.log(this.state.Roles) );
// this.setState({Roles : this.state.RoleFamilies.find(cntry => cntry.name === event.target.value).Roles});
  //  console.log("from country change map ", this.state.Roles);

  //  this.setState({ Roles : Array.from(new Set(this.state.RoleFamilies.map(element => element[event.target.value]))) }) 
   
  //  let options = Array.from(new Set(this.state.RoleFamilies.map(element => element[e])));
    //console.log("from country change ",this.state.Roles);
	}

	// changeState(event) {
	// 	this.setState({selectedState: event.target.value,
  //   level: Array.from(this.state.Roles.find((level,index) => level.name === event.target.value).level)},
  //   ()=>console.log(this.state.level)   
  //    );
    
  
	// 	// const stats = this.state.RoleFamilies.find(cntry => cntry.name === this.state.selectedCountry).Roles;
	// 	// this.setState({cities : stats.find(stat => stat.name === event.target.value).cities});
	// }


  changeState(event) {

    let levelArray =  Array.from(this.state.Roles.find(level => level.name === event.target.value).level);
    let levelPlaceHolderValue = "--SelectCity--";
    if(levelArray.length === 1){

      levelPlaceHolderValue = levelArray[0];

    }

    let value = event.target.value;

    console.log ("From filter",value);
    if(value) {
      // let { filterOption } = this.state;
      // let filteredData = data.filter(element => element[filterOption] == value);
      let filteredData = data.filter(element => element.Role === value);
      console.log ("From filter comparison Filtered data lenght",filteredData.length);
      
    }

    
    this.setState({

      selectedState: event.target.value,

      level:levelArray,

      levelPlaceHolderValue :levelPlaceHolderValue,

      filteredData: data.filter(element => element.Role === value)
  },

      ()=>{

        console.log(this.state.level);

      }  

    );



  }


  renderTableData(data) {
    return data.map((element, i) => (
      <tr key={i}> 
        <td style={{textAlign:'left'}}>{element.CourseName}</td>
        <td>{element.CourseType}</td>
        <td><a target="_blank" href={element.CourseLink}>Link</a></td>
        <td>{element.Duration}</td> 
      </tr>
    ))
  }
	

  renderEmptySpace(){

    return (
      <h4 style={{marginTop:'20px'}}> Select the Role Family and Role to get the recommended learning !  </h4>
    )
  }

	render() {
    let { filterOption, filteredData } = this.state
		return (



			<div id="container">
        <div className="main-container" id="rolebasedcontent-box">
            <title>Security Learning - Role based</title>
            <img src={process.env.PUBLIC_URL +"/images/entry-level-banner.png"} className="banner-img"/>
            <Navbarmenu/>
        </div>
        <Container className='role-based-container' maxWidth="xl">
          <div className="role-based-wrap">
              <p>Here is the opportunity to equip yourself with the security skills required for your day-to-day activities and beyond. There is a guidance provided for your career level and the respective role. This is not a limitation while you can explore more. Select career level and role you are playing to get the security learning guidance.</p>
          </div>
          <div className="filter-container">
            <div className="filter-wrap">

              <div className="filter-row row1">
                <div className="filter-box">
                  <label>Role Family:</label>
                  <select id="role-box1" placeholder="Country" value={this.state.selectedCountry} onChange={this.changeCountry}>
                    <option>--Choose RoleFamily--</option>
                    {this.state.RoleFamilies.map((e, key) => {
                      return <option key={key}>{e.name}</option>;
                    })}
                  </select>
                </div>
              </div>

              <div className="filter-row row2">
                <div className="filter-box">
                  <label>Role:</label>
                  <select id="role-box2" placeholder="State" value={this.state.selectedState} onChange={this.changeState}>
                    <option>--Choose Role--</option>
                    {this.state.Roles.map((e, key) => {
                      return <option key={key}>{e.name}</option>;
                    })}
                  </select>
                </div>
              </div>
            
              <div className="filter-row row3">
                <div className="filter-box">
                  <label>Level:</label>
                  <select id="role-box3" placeholder={this.state.levelPlaceHolderValue}>
                    {/* <option>--Choose City--</option> */}
                    {this.state.level.map((e, key) => {
                      return <option key={key}>{e}</option>;
                    })}
                  </select>
                </div>
              </div>

              <div className="filter-row row4">
                <div className="filter-box">
                  <button onClick={()=>this.setState({ filteredData: [],Roles : [],level: [] })} className="reset-btn">Reset</button> 
                </div>
              </div>

            </div>

            <table id="career-table">
              <thead>
                <th > Course Name</th>
                <th> Course Type </th>
                <th> Course Link</th>
                <th> Duration </th>
              </thead>
              <tbody>
                {
                  filteredData.length? this.renderTableData(filteredData) : this.renderEmptySpace() 
                }
              </tbody>
            </table>
          </div>
        </Container>
			</div>
		)
	}
}

export default RoleBasedContentDemo;